import { FC, useEffect } from "react";

import { useAv } from "../../../utils/av";

import { t } from "i18n/i18n";
import { IconText } from "mds/components/IconText";
import { MenuItem } from "mds/components/Menu";
import { SquareIconButton } from "mds/components/buttons/SquareIconButton";
import { HandRaiseFilledIcon, HandRaiseIcon } from "mds/icons";
import { useAppSelector } from "store/index";
import { selectCurrentClassUserId } from "store/selectors";
import { selectIsVirtualUserSpeaking } from "store/selectors/pubsub-virtual-class-state";

const LOWER_HAND_TIMEOUT_DURATION_MS = 3000;

export const HandRaiseButton: FC<{ isMobile?: boolean; isMenuItem?: boolean }> = ({
  isMobile = false,
  isMenuItem = false,
}) => {
  const { isHandRaised, toggleHand } = useAv();
  const currentClassUserId = useAppSelector(selectCurrentClassUserId);
  const isSpeaking = useAppSelector((state) =>
    currentClassUserId ? selectIsVirtualUserSpeaking(state, currentClassUserId) : false,
  );

  useEffect(() => {
    if (!isHandRaised || !isSpeaking) return;
    const timeoutId = setTimeout(() => toggleHand(), LOWER_HAND_TIMEOUT_DURATION_MS);
    return () => clearTimeout(timeoutId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isHandRaised, isSpeaking]);

  if (isMenuItem) {
    return (
      <MenuItem eventName={isHandRaised ? "Lower hand" : "Raise hand"} onClick={toggleHand}>
        <IconText
          iconStart={isHandRaised ? <HandRaiseFilledIcon /> : <HandRaiseIcon />}
          text={isHandRaised ? t("av.lower_hand") : t("av.raise_hand")}
        />
      </MenuItem>
    );
  }

  return (
    <SquareIconButton
      eventName={isHandRaised ? "Lower hand" : "Raise hand"}
      isSelected={isHandRaised}
      kind="secondary"
      size={isMobile ? "xl" : "l"}
      title={t(isHandRaised ? "av.lower_hand" : "av.raise_hand")}
      onClick={toggleHand}
    >
      {isHandRaised ? <HandRaiseFilledIcon /> : <HandRaiseIcon />}
    </SquareIconButton>
  );
};
